// ======================================================================================|
//  MARK: Feature Flags

export interface FeatureFlags {
  /** Gates all v2 functionality. Toggle on to reveal v2 features globally. */
  V2: boolean;
  /** Instant kill switch — blocks user-facing operations without redeployment. */
  MAINTENANCE_MODE: boolean;
  /**
   * Gates the "Changes Since Last Audit" / DiffBand surface across every
   * engine page and the overview hero. Default ON in prod (A7Y-1132);
   * retained as a kill switch — flip to off if the diff classifier
   * regresses. Toggle locally with `?change_tracking=false`.
   */
  CHANGE_TRACKING: boolean;
  /**
   * A7Y-3380 — gates the quality-gated per-pillar action bullets in the audit
   * completion/run emails. Default OFF: enablement is a post-run Yevhen
   * calibration-review decision, not a code change.
   */
  AUDIT_EMAIL_ACTION_BULLETS: boolean;
  /**
   * A7Y-4799 — the keyword engine reads candidate keywords from the keyword
   * corpus first and runs live suggestion discovery only for seeds the corpus
   * cannot answer. Default OFF; turned on in A7Y-4801 together with the
   * engine-version bump.
   */
  KW_CORPUS_CANDIDATES: boolean;
  /**
   * A7Y-5130 — one Monday email per app (one per account with 4+ apps) replaces
   * the scheduled-audit report and the competitor digest. Default OFF: it is
   * switched on by a gated follow-up after Yevhen approves the rendered emails.
   */
  WEEKLY_REPORT_EMAIL: boolean;
}

export type FeatureFlagName = keyof FeatureFlags;

/** Firestore document shape for the FeatureFlags collection. Doc ID = flag name. */
export interface FeatureFlagDoc {
  name: FeatureFlagName;
  enabled: boolean;
  description: string;
  updatedAt: string;
  updatedBy: string;
}

/** Default values for all feature flags. Used when no Firestore document exists. */
export const FLAG_DEFAULTS: FeatureFlags = {
  V2: false,
  MAINTENANCE_MODE: false,
  CHANGE_TRACKING: true,
  AUDIT_EMAIL_ACTION_BULLETS: false,
  KW_CORPUS_CANDIDATES: false,
  WEEKLY_REPORT_EMAIL: false,
};
